'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*

  Declare and export all constants here

  e.g.

  export default {
    openInlineCart: 'PRG.OPEN_INLINE_CART',
    closeInlineCart: 'PRG.CLOSE_INLINE_CART',
  };

*/

exports.default = {
  // ANIMATION
  animationEnd: 'PRG.ANIMATION.END',
  animationStart: 'PRG.ANIMATION.START',

  // CART
  addToCart: 'PRG.CART.ADD',
  updateCart: 'PRG.CART.UPDATE',
  removeFromCart: 'PRG.CART.REMOVE',
  batchRequests: 'PRG.CART.BATCH',

  enqueueRequest: 'PRG.REQUEST.ENQUEUE',
  dequeueRequest: 'PRG.REQUEST.DEQUEUE',
  requestError: 'PRG.REQUEST.ERROR',
  requestSuccess: 'PRG.REQUEST.SUCCESS',

  // INLINE_CART
  openInlineCart: 'PRG.INLINE_CART.OPEN',
  closeInlineCart: 'PRG.INLINE_CART.CLOSE',
  toggleInlineCart: 'PRG.INLINE_CART.TOGGLE',
  updateInlineCartUIStart: 'PRG.INLINE_CART.UPDATE.START',
  updateInlineCartUISuccess: 'PRG.INLINE_CART.UPDATE.SUCCESS',
  updateInlineCartUIError: 'PRG.INLINE_CART.UPDATE.FAIL',

  // OPTION_VALUE
  optionValueChange: 'PRG.OPTION_VALUE.UPDATE',

  // PRICE
  updatePrice: 'PRG.PRICE.UPDATE',
  updateProductPrice: 'PRG.PRICE.PRODUCT.UPDATE',

  // TOGGLE
  toggle: 'PRG.TOGGLE',

  // VARIANT
  updateVariant: 'PRG.VARIANT.UPDATE',
  updateVariantId: 'PRG.VARIANT_ID.UPDATE',

  // MODAL
  hideModal: 'PRG.MODAL.HIDE',
  showModal: 'PRG.MODAL.SHOW',
  openModal: 'PRG.MODAL.OPEN',
  closeModal: 'PRG.MODAL.CLOSE',
  toggleModal: 'PRG.MODAL.TOGGLE',

  // OVERLAY
  showOverlay: 'PRG.OVERLAY.SHOW',
  hideOverlay: 'PRG.OVERLAY.HIDE',

  // QUICKSHOP
  openQuickshop: 'PRG.QUICKSHOP.OPEN',
  closeQuickshop: 'PRG.QUICKSHOP.CLOSE',
  toggleQuickshop: 'PRG.QUICKSHOP.TOGGLE',

  // SLIDER
  updateSliderSlide: 'PRG.SLIDER.UPDATE',
  updateContainerSliders: 'PRG.CONTAINER.SLIDERS.UPDATE',

  // STATE
  state: 'PRG.STATE',
  initState: 'PRG.STATE.INIT',
  createState: 'PRG.STATE.CREATE',
  updateState: 'PRG.STATE.UPDATE',
  deleteState: 'PRG.STATE.DELETE',
  updateQuantity: 'PRG.STATE.QUANTITY',

  // PRODUCT CONTAINER
  variantChange: 'PRG.STATE.VARIANT.PRODUCT',
  updateInventory: 'PRG.STATE.INVENTORY.PRODUCT',
  updateVariantMap: 'PRG.STATE.UPDATE.VARIANT',
  updateOptionValue: 'PRG.STATE.OPTION_VALUE.PRODUCT',
  updateProductQuantity: 'PRG.STATE.QUANTITY.PRODUCT',
  updateInventoryState: 'PRG.STATE.UPDATE.INVENTORY',
  allProductContainersInit: 'PRG.STATE.INIT.ALL_PRODUCT',
  allLineItemContainersInit: 'PRG.STATE.INIT.ALL_LINE_ITEM',
  allContainersInit: 'PRG.STATE.INIT.ALL',

  // CART
  updateCartState: 'PRG.STATE.UPDATE.CART',

  // LINE ITEM
  updateLineItem: 'PRG.STATE.LINE_ITEM',
  updateLineItemQuantity: 'PRG.STATE.QUANTITY.LINE_ITEM',

  // FLOW
  flowReady: 'PRG.FLOW.READY',
  flowLocalized: 'PRG.FLOW.LOCALIZED',

  error: 'PRG.ERROR',

  // COLLECTION
  collectionGridPopulated: 'PRG.COLLECTION.POPULATED'
};